import React, { useEffect, useState, useRef, forwardRef } from 'react';
import styled from 'styled-components';
import Icon from './Icon';
import Title from './Title';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: ${({ collapsed }) => collapsed ? '0.4em 1em' : '1.5em'};
    border-radius: 1rem;
    color: ${({ theme }) => theme.text};
    background: ${({ theme }) => theme.background};
    box-shadow: 0px 3px 10px ${({ theme }) => theme.shadow};
    transition: all 0.2s;

    ${({ height, collapsed }) => collapsed ? `height: 2em;` : height && `height: ${height}px;`};

    ${({ noSlide }) => !noSlide ? 'animation:  slideInFromRight 0.3s;' : ''}
`
const Overflow = styled.div`
    // overflow-y: hidden;
`
const HeightWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5em;
`
const Row = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.2s;
    height: 2em;
`
const I = styled(Icon)`
    transform: rotate(${({ collapsed }) => collapsed ? '90deg' : '0deg'});
    transition: all 0.3s;
`

const Card = forwardRef(({ smooth, children, ...props }, fwdRef) => {
    const [cardHeight, setCardHeight] = useState(null)
    const [collapsed, setCollapsed] = useState(props.collapsible)
    const cardRef = useRef(null)

    const observer = useRef(
        new ResizeObserver(entries => {
            const { height } = entries[0].contentRect
            setCardHeight(height)
        })
    )

    useEffect(() => {
        const element = observer.current;
        const ref = cardRef.current;

        if (element) {
            element.observe(ref)
        }

        return () => element.unobserve(ref)
    }, [cardRef, observer])

    const handleClick = (e, body) => {
        if (!props.collapsible) return;
        setCollapsed(!collapsed);
    }

    return (
        <Wrapper ref={fwdRef} height={cardHeight} collapsed={collapsed} noSlide={props.noSlide} {...props}>
            <Overflow>
                <HeightWrapper ref={cardRef} >
                    {
                        props.collapsible ?
                            <Row collapsed={collapsed} onClick={handleClick}>
                                <Title icon={props.icon}>{props.title}</Title>
                                <I icon='chevronDown' collapsed={collapsed ? 1 : 0} />
                            </Row> :
                            props.title ?
                                <Title icon={props.icon}>{props.title}</Title> : null
                    }
                    {children}
                </HeightWrapper>
            </Overflow>
        </Wrapper>
    );
})

export default Card;